// extracted by mini-css-extract-plugin
export default {"text":"ContestPage_text__gVQaZ","explanationDoc":"ContestPage_explanationDoc__5jMb8"};